import { demoFile, component, story, CLICK } from 'system/demo';
import { DialogueWideQuestionTeaserWithComment, DialogueNarrowQuestionTeaserWithComment, DialogueAdaptiveLayoutQuestionTeaser, DialogueAdaptiveLayoutArticleQuestionTeaserWithComment, DialogueQuestionInfo, teaserPalette } from 'open-modules/srg/feature/teaser/dialog-teaser';

const questionText = 'Is Godzilla good?';
const questionKey = 'q1';
const commentPreview = { key: 'c1', from: 'u1', text: 'Yes, definitely.', time: Date.now() };

const baseState = {
    personaKey: 'u1',
    collections: {
        vote: [],
        derived_questionPreview: [{ key: questionKey, commentPreview, commentCount: 1 }]
    }
};

const baseConfig = { teaserColorPalette: teaserPalette.green };

demoFile('open-modules/srg/feature/teaser/dialog-teaser');

component('DialogueWideQuestionTeaserWithComment', DialogueWideQuestionTeaserWithComment, {
    args: { questionText, commentPreview, commentCount: 1 },
    state: baseState,
    config: baseConfig
});

component('DialogueNarrowQuestionTeaserWithComment', DialogueNarrowQuestionTeaserWithComment, {
    args: { questionText, commentPreview, commentCount: 1 },
    state: baseState,
    config: baseConfig
});

component('DialogueAdaptiveLayoutQuestionTeaser', DialogueAdaptiveLayoutQuestionTeaser, {
    args: { questionText, questionKey, entryUrl: '/q1', commentPreview, commentCount: 1 },
    state: baseState,
    config: baseConfig
}, [
    story('Press teaser', [CLICK('question-teaser')])
]);

component('DialogueAdaptiveLayoutArticleQuestionTeaserWithComment', DialogueAdaptiveLayoutArticleQuestionTeaserWithComment, {
    args: { question: { key: questionKey, text: questionText } },
    state: baseState,
    config: baseConfig
}, [
    story('Press article teaser', [CLICK('question-teaser')])
]);

component('DialogueQuestionInfo', DialogueQuestionInfo, {
    args: { questionText, commentCount: 1 },
    config: baseConfig
});
